import { createAsyncThunk } from '@reduxjs/toolkit';
import InfluencerExampleService from '../../../api/services/InfluencerExampleService';

export const fetchInfluencerExamples = createAsyncThunk(
  'influencerExamples/fetchInfluencerExamples',
  async ({ page, search }) => {
    return await InfluencerExampleService.fetchInfluencerExamples(page, search);
  },
);

export const revertInfluencerExample = createAsyncThunk(
  'influencerExamples/revertInfluencerExample',
  async ({ influencerExampleId }) => {
    return await InfluencerExampleService.revertInfluencerExample(influencerExampleId);
  },
);

export const editInfluencerExample = createAsyncThunk(
  'influencerExamples/editInfluencerExample',
  async ({ influencerExampleId, text }) => {
    return await InfluencerExampleService.editInfluencerExample(influencerExampleId, text);
  },
);
